import { z } from 'zod';

/** Décimal transporté en chaîne (« 1.20 ») ; accepte nombre, virgule ou point. */
export const decimalString = z
  .union([z.string(), z.number()])
  .transform((v) => (typeof v === 'number' ? String(v) : v.trim().replace(',', '.')))
  .refine((v) => /^-?\d+(\.\d+)?$/.test(v), { error: 'Nombre décimal attendu' });

export const positiveDecimal = decimalString.refine((v) => Number(v) >= 0, { error: 'Valeur positive attendue' });
export const rate = decimalString.refine((v) => Number(v) >= 0 && Number(v) <= 1, { error: 'Taux entre 0 et 1 attendu (ex. 0.18 pour 18 %)' });
